import { Tooltip } from "antd";
import { getSitucaoProcessoJudicial } from "constants/EnumTipoSituacaoProcessoJudicial";
import { BsFillTrashFill } from "react-icons/bs";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import {
  formatarData,
  formatarHorarioParaHoraMinuto,
} from "shared/util/functions/formatacoesDeValores/FormatarValores";
import parse from "html-react-parser";
import { RegistroProcessoJudicialHistoricoDTO } from "types/dto/RegistroProcessoJudicialHistoricoDTO";
import showAlert from "shared/util/functions/alert/showAlert";
import { useDeleteProcessoJudicialHistorico } from "hooks/processosJudiciais/useDeleteProcessoJudicialHistorico";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";
import { ProcessoJudicialHistoricoDTO } from "types/dto/ProcessoJudicialHistoricoDTO";

interface RenderRowsVisualizarProcessosJudiciaisHistoricosProps {
  registros: RegistroProcessoJudicialHistoricoDTO[];
}

const RenderRowsVisualizarProcessosJudiciaisHistoricos: React.FC<
  RenderRowsVisualizarProcessosJudiciaisHistoricosProps
> = (props) => {
  const { mutate: deleteExcluirAgendamento } = useDeleteProcessoJudicialHistorico();
  const { isVisualizacao } = useProcessosJudiciaisContext();

  const renderizarAnotacoesComQuebraDeLinha = (dados: string) => {
    if (dados === null || dados === undefined || dados === " ") {
      return "-";
    }
    return parse(dados.replaceAll("\n", "<br>"));
  };

  const handleDeleteProcessoJudicialHistorico = (processoJudicialHistoricoId: number) => {
    showAlert({
      texto: "Você realmente deseja excluir?",
      tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
      onConfirm: () => {
        deleteExcluirAgendamento(processoJudicialHistoricoId);
      },
    });
  };
  const getTituloTooltip = (isGeradoPeloSistema: boolean) => {
    return isGeradoPeloSistema ? "Históricos adicionados automaticamente não poderão ser excluídos" : "Excluir";
  };

  const renderRegistros = () => {
    return props.registros.map((registro: RegistroProcessoJudicialHistoricoDTO, index: number) => {
      return (
        <LinhaTabela
          id={`id-registro-processo-judicial-historico-${index}`}
          key={`key-registro-processo-judicial-historico-${index}`}
        >
          <RegistroTabela
            id={`data-processo-judicial-historico-${index}`}
            key={`key-data-processo-judicial-historico-${index}`}
          >
            <span>{`${formatarData(registro.data)} - ${formatarHorarioParaHoraMinuto(registro.hora)}`}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`historico-processo-judicial-historico-${index}`}
            key={`key-historico-processo-judicial-historico-${index}`}
          >
            <div>{renderizarAnotacoesComQuebraDeLinha(registro.anotacoes)}</div>
          </RegistroTabela>

          <RegistroTabela
            id={`situacao-processo-judicial-historico-${index}`}
            key={`key-situacao-processo-judicial-historico-${index}`}
          >
            <span>{`${
              registro.situacao !== null && registro.situacao !== undefined
                ? getSitucaoProcessoJudicial(registro.situacao)
                : "-"
            }`}</span>
          </RegistroTabela>

          <RegistroTabela
            id={`excluir-processo-judicial-historico-${index}`}
            key={`key-excluir-processo-judicial-historico-${index}`}
          >
            {!isVisualizacao && (
              <Tooltip placement="top" title={getTituloTooltip(registro.isGeradoPeloSistema)}>
                <a onClick={() => !registro.isGeradoPeloSistema && handleDeleteProcessoJudicialHistorico(registro.id)}>
                  <BsFillTrashFill
                    className={` ${registro.isGeradoPeloSistema ? "disable-icon" : "cursor-pointer"}`}
                    size={15}
                    color="#a69ae7"
                  />
                </a>
              </Tooltip>
            )}
          </RegistroTabela>
        </LinhaTabela>
      );
    });
  };
  return <>{renderRegistros()}</>;
};

export default RenderRowsVisualizarProcessosJudiciaisHistoricos;
